import { createRouter, createWebHistory } from 'vue-router'
import Home from '../components/Home.vue'
import Download from '../components/Download.vue'
import Support from '../components/Support.vue'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/download',
    name: 'Download',
    component: Download
  },
  {
    path: "/support",
    name: "Support",
    component: Support
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes,
  // 添加滚动行为配置
  scrollBehavior(to, from, savedPosition) {
    // 如果有保存的位置（如浏览器后退），则返回到该位置
    if (savedPosition) {
      return savedPosition;
    }
    // 否则滚动到顶部
    return { top: 0, behavior: 'instant' };
  }
})

export default router